import { render, staticRenderFns } from "./list-header.vue?vue&type=template&id=897fe59a"
import script from "./list-header.vue?vue&type=script&lang=js"
export * from "./list-header.vue?vue&type=script&lang=js"
import style0 from "./list-header.vue?vue&type=style&index=0&id=897fe59a&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports